/*
bigbang.ba - produkcija
sdba.bigbangmarkerdev.info - dev
beta.bigbang.ba - dev s produkcijskim podacima
*/

export const config = {
	default: 'prod',
	sdba: {
		host: 'https://sdba.bigbangmarkerdev.info',
		lang: 'ba',
		apiCache: false,
		routeCacheExpire: 0, // 5 min
	},
	beta: {
		host: 'https://beta.bigbang.ba',
		lang: 'ba',
		apiCache: false,
		routeCacheExpire: 0,
	},	
	prod: {
		host: 'https://www.bigbang.ba',
		lang: 'ba',
		apiCache: true,
		routeCacheExpire: 305, // 5 min
	},
};